import { FC } from 'react';
import { ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { AsyncCell } from 'components/ScalarSpreadsheet/components/AsyncCell';
import { useGrossIRR } from './FirmSummaryAsyncCells.contexts';

/**
 * Totals-row Gross IRR (SCAL-9410). GET /api/firms/{firm}/summary walks cash-flow ledger rows
 * and can take seconds; subscribing here means the grid renders from the definition data and
 * this single cell resolves on its own instead of repainting the sheet when the value lands.
 */
const GrossIRRCell: FC<Pick<ValueViewerProps, 'cell'>> = ({ cell }) => {
  const { grossIRR, isLoading } = useGrossIRR();

  return <AsyncCell cell={cell} isLoading={isLoading} value={grossIRR} />;
};

export default GrossIRRCell;
